import { BankType, BrandType, Country } from '../../generated/graphql';
import { getSpaceBancoDeBogota } from '../entities/banco_de_bogota/getSpaceBancoDeBogota';
import { getSpaceBbva } from '../entities/bbva/getSpaceBbva';
import { getSpaceDavivienda } from '../entities/davivienda/getSpaceDavivienda';
import { getSpaceRappipay } from '../entities/rappipay/getSpaceRappipay';
import { getSpaceRappiPrestamo } from '../entities/rappiPrestamo/getSpaceRappiPrestamo';
import { getSpacePichincha } from '../entities/pichincha/getSpacePichincha';
import { getSpaceClaro } from '../entities/claro/getSpaceClaro';
import { GetSpaceBase } from '../types/GetSpaceBase';
import { getUndefinedSpace } from '../utils/getUndefinedSpace';
import { getSpaceApex } from '../entities/apex/getSpaceApex';
import { getSpacePra } from '../entities/pra/getSpacePra';
import { getSpaceJCAP } from '../entities/jcap/getSpaceJcap';

const { Tranquiapp } = BrandType;
const {
  BancoDeBogota,
  Bbva,
  BancoDavivienda,
  Pichincha,
  Rappipay,
  RappiPrestamo,
  Claro,
} = BankType;

export const getSpaceByEntity: GetSpaceBase = (
  group,
  space,
  context,
  extra,
) => {
  const { bank, brand, country } = context;

  // we don't have other countries at the moment
  if (country !== Country.Co) return getUndefinedSpace(true);

  if (brand === Tranquiapp) {
    switch (bank) {
      case Bbva: return getSpaceBbva(group, space, context, extra);
      case BancoDavivienda: return getSpaceDavivienda(group, space, context, extra);
      case BancoDeBogota: return getSpaceBancoDeBogota(group, space, context, extra);
      case Pichincha: return getSpacePichincha(group, space, context, extra);
      case Rappipay: return getSpaceRappipay(group, space, context, extra);
      case RappiPrestamo: return getSpaceRappiPrestamo(group, space, context, extra);
      case Claro: return getSpaceClaro(group, space, context, extra);
      default: return getUndefinedSpace();
    }
  }
  if (brand === BrandType.Apex) {
    return getSpaceApex(group, space, context, extra);
  }
  if (brand === BrandType.Pra) {
    return getSpacePra(group, space, context, extra);
  }
  if (brand === BrandType.Jcap) {
    return getSpaceJCAP(group, space, context, extra);
  }
  return getUndefinedSpace();
};
